import { useContext } from "react";

import Hamburger from "./Hamburger";
import HelpfulLinks from "./HelpfulLinks";
import Icon from "../icon/Icon";
import T from "../translations/Translations";

import { GlobalContext } from "../contextProvider/ContextProvider";
import { GUARDIAN_DASHBOARD } from "../../utils/auth/config";
import { logout } from "../../utils/auth/Auth";
import { SetSchoolYearDto } from "../contextProvider/ContextSetter";
import { useActionControls } from "../../utils/ActionControls";

import "../../styles/Header.scss";

/**
 * This is returning the header content with buttons and links
 * @name Header
 * @return {JSX.Element}
 */
const Header = () => {
    const { state } = useContext(GlobalContext);
    const { userDetails } = state || {};

    // UserDetails is returning an object with keys, name, employeeNumber,
    // givenName, displayName, email, surname, uid, category, position, etc.
    const { givenName, surname } = userDetails || {};

    const dashboard = () => {
        window.location.href = GUARDIAN_DASHBOARD;
    };

    /**
     * Set the SchoolYearDto in context
     */
    SetSchoolYearDto();

    useActionControls();

    return (
        <nav className="header-container">
            <div className="header-left">
                <div className="header-dcsd-icon">
                    <a
                        aria-label="Guardian Dashboard Page Link"
                        href={GUARDIAN_DASHBOARD}
                        onClick={() => {
                            sessionStorage.clear();
                            return true;
                        }}
                        rel="noopener noreferrer"
                        style={{
                            textDecoration: "none",
                            color: "black"
                        }}
                        tabIndex={0}
                    >
                        <Icon fill="#0669B3" height={60} iconName="DCSD" width={60} />
                    </a>
                </div>
                <div className="header-name-container">
                    <h5 className="header-name">
                        {/* Welcome */}
                        {T({ key: "Main_Nav_Welcome" })} {givenName} {surname}
                    </h5>
                </div>
            </div>
            <div className="header-right">
                <div className="nav-button-container">
                    <HelpfulLinks />
                    <button
                        aria-label="Dashboard Button"
                        className="btn btn-primary m-2 color-override"
                        onClick={dashboard}
                        onKeyDown={dashboard}
                        type="button"
                    >
                        <span className="nav-button-text">{T({ key: "Global_Dashboard" })}</span>
                    </button>
                    <button
                        aria-label="Logout Button"
                        className="btn btn-primary m-2 color-override"
                        onClick={logout}
                        onKeyDown={logout}
                        type="button"
                    >
                        <span className="nav-button-text">{T({ key: "Main_Nav_LogOut" })}</span>
                    </button>
                </div>
                <div className="mobile-hamburger">
                    <Hamburger />
                </div>
            </div>
        </nav>
    );
};

export default Header;
